export const DEALSTAGE = {
  TYPE: 'DEALSTAGE',
  LIST_ERROR: "Dealstages can't be fetched. Try again!",
  GET_ERROR: "Dealstage Detail can't be fetched. Try again!",
  DELETE_ERROR: "Dealstage can't be deleted. Try again!",
  EDIT_ERROR: "Dealstage can't be edited. Try again!",
};

export const DEALSTAGELOGS = {
  TYPE: 'USER',
  LIST_ERROR: "Users history can't be fetched. Try again!",
  GET_ERROR: "User history can't be fetched. Try again!",
};

export const LOCATION = {
  TYPE: 'LOCATION',
  LIST_ERROR: "Locations can't be fetched. Try again!",
  GET_ERROR: "Location Detail can't be fetched. Try again!",
  ADD_ERROR: "Location can't be added. Try again!",
  DELETE_ERROR: "Location can't be deleted. Try again!",
  EDIT_ERROR: "Location can't be edited. Try again!",
};

export const USER = {
  TYPE: 'USER',
  LIST_ERROR: "Contacts can't be fetched. Try again!",
  GET_ERROR: "Contact Detail can't be fetched. Try again!",
  ADD_ERROR: "Contact can't be added. Try again!",
  DELETE_ERROR: "Contact can't be deleted. Try again!",
  EDIT_ERROR: "Contact can't be edited. Try again!",
};

export const USERLOGS = {
  TYPE: 'USER',
  LIST_ERROR: "Contacts history can't be fetched. Try again!",
  GET_ERROR: "Contact history Detail can't be fetched. Try again!"
};

export const AUTH = {
  TYPE: 'AUTH',
  GET_ERROR: "User Detail can't be fetched. Try again!",
  EDIT_ERROR: "User can't be edited. Try again!",
  SESSION_EXPIRED: 'Session has expired, Please login again.',
  NO_INTERNET:
    'CarBlip requires a network connection to work properly.  Please check your WiFi or internet connection.',
  SERVER_DOWN:
    "It's taking longer than expected.  Please check your connection and try again.",
  SOMETHING_WRONG:
    'Woops!  Something went wrong.  Please close the app and restart.',
};

export const PORTALUSER = {
  TYPE: 'USER',
  LIST_ERROR: "Users can't be fetched. Try again!",
  GET_ERROR: "User Detail can't be fetched. Try again!",
  ADD_ERROR: "User can't be added. Try again!",
  DELETE_ERROR: "User can't be deleted. Try again!",
  EDIT_ERROR: "User can't be edited. Try again!",
};

export const PORTALUSERLOGS = {
  TYPE: 'USER',
  LIST_ERROR: "Users history can't be fetched. Try again!",
  GET_ERROR: "User history can't be fetched. Try again!",
};

export const REQUEST = {
  TYPE: 'REQUEST',
  LIST_ERROR: "Requests can't be fetched. Try again!",
  GET_ERROR: "Request Detail can't be fetched. Try again!",
  ADD_ERROR: "Request can't be added. Try again!",
  DELETE_ERROR: "Request can't be deleted. Try again!",
  EDIT_ERROR: "Request can't be edited. Try again!",
};

export const DEAL = {
  TYPE: 'DEAL',
  LIST_ERROR: "Deals can't be fetched. Try again!",
  GET_ERROR: "Deal Detail can't be fetched. Try again!",
  ADD_ERROR: "Deal can't be added. Try again!",
  DELETE_ERROR: "Deal can't be deleted. Try again!",
  EDIT_ERROR: "Deal can't be edited. Try again!",
};

export const DEALLOGS = {
  TYPE: 'DEAL',
  LIST_ERROR: "Deals history can't be fetched. Try again!",
  GET_ERROR: "Deal history can't be fetched. Try again!"
};

export const QUOTE = {
  TYPE: 'QUOTE',
  LIST_ERROR: "Quotes can't be fetched. Try again!",
  GET_ERROR: "Quote Detail can't be fetched. Try again!",
  ADD_ERROR: "Quote can't be added. Try again!",
  DELETE_ERROR: "Quote can't be deleted. Try again!",
  EDIT_ERROR: "Quote can't be edited. Try again!",
};

export const WHOLESALEQUOTE = {
  TYPE: 'WHOLESALEQUOTE',
  LIST_ERROR: "WholesaleQuote can't be fetched. Try again!",
  GET_ERROR: "WholesaleQuote Detail can't be fetched. Try again!",
  ADD_ERROR: "WholesaleQuote can't be added. Try again!",
  DELETE_ERROR: "WholesaleQuote can't be deleted. Try again!",
  EDIT_ERROR: "WholesaleQuote can't be edited. Try again!",
};

export const VENDORS = {
  TYPE: 'VENDORS',
  LIST_ERROR: "Vendors can't be fetched. Try again!",
  GET_ERROR: "Vendors Detail can't be fetched. Try again!",
  ADD_ERROR: "Vendors can't be added. Try again!",
  DELETE_ERROR: "Vendors can't be deleted. Try again!",
  EDIT_ERROR: "Vendors can't be edited. Try again!",
};

export const PURCHASEORDER = {
  TYPE: 'PURCHASEORDER',
  LIST_ERROR: "Purchase order can't be fetched. Try again!",
  GET_ERROR: "Purchase order Detail can't be fetched. Try again!",
  ADD_ERROR: "Purchase order can't be added. Try again!",
  DELETE_ERROR: "Purchase order can't be deleted. Try again!",
  EDIT_ERROR: "Purchase order can't be edited. Try again!",
};

export const CARSDIRECT = {
  TYPE: 'CARSDIRECT',
  LIST_ERROR: "Carsdirect Deal can't be fetched. Try again!",
  GET_ERROR: "Carsdirect Detail can't be fetched. Try again!",
  ADD_ERROR: "Carsdirect can't be added. Try again!",
  DELETE_ERROR: "Carsdirect can't be deleted. Try again!",
  EDIT_ERROR: "Carsdirect can't be edited. Try again!",
};

export const BLOCKLIST = {
  TYPE: 'BLOCKLIST',
  LIST_ERROR: "Block list can't be fetched. Try again!",
  GET_ERROR: "Blocked Number Detail can't be fetched. Try again!",
  ADD_ERROR: "Blocked Number can't be added. Try again!",
  DELETE_ERROR: "Blocked Number can't be deleted. Try again!",
  EDIT_ERROR: "Blocked Number can't be edited. Try again!",
};

export const INVENTORY = {
  TYPE: 'INVENTORY',
  LIST_ERROR: "Inventories can't be fetched. Try again!",
  GET_ERROR: "Inventory Detail can't be fetched. Try again!",
  ADD_ERROR: "Inventory can't be added. Try again!",
  DELETE_ERROR: "Inventory can't be deleted. Try again!",
  EDIT_ERROR: "Inventory can't be edited. Try again!",
};

export const MDEALER = {
  TYPE: 'MDEALER',
  LIST_ERROR: "Dealers can't be fetched. Try again!",
  GET_ERROR: "Dealer Detail can't be fetched. Try again!",
  ADD_ERROR: "Dealer can't be added. Try again!",
  DELETE_ERROR: "Dealer can't be deleted. Try again!",
  EDIT_ERROR: "Dealer can't be edited. Try again!",
};

export const DEALER = {
  TYPE: 'DEALER',
  LIST_ERROR: "Dealers can't be fetched. Try again!",
  GET_ERROR: "Dealer Detail can't be fetched. Try again!",
  ADD_ERROR: "Dealer can't be added. Try again!",
  DELETE_ERROR: "Dealer can't be deleted. Try again!",
  EDIT_ERROR: "Dealer can't be edited. Try again!",
};

export const REPORT = {
  TYPE: 'REPORT',
  LIST_ERROR: "Reports can't be fetched. Try again!",
  GET_ERROR: "Report Details can't be fetched. Try again!",
};

export const CLIENTFILES = {
  TYPE: 'CLIENTFILES',
  LIST_ERROR: "Client files can't be fetched. Try again!",
  GET_ERROR: "Client files Details can't be fetched. Try again!",
};

export const WORKFLOW = {
  TYPE: 'WORKFLOW',
  LIST_ERROR: "Workflow can't be fetched. Try again!",
  GET_ERROR: "Workflow Detail can't be fetched. Try again!",
  ADD_ERROR: "Workflow can't be added. Try again!",
  DELETE_ERROR: "Workflow can't be deleted. Try again!",
  EDIT_ERROR: "Workflow can't be edited. Try again!",
};

export const WORKFLOWLOGS = {
  TYPE: 'WORKFLOWLOGS',
  LIST_ERROR: "Workflows history can't be fetched. Try again!",
  GET_ERROR: "Workflow history Detail can't be fetched. Try again!"
};

export const SMSTEMPLATE = {
  TYPE: 'SMSTEMPLATE',
  LIST_ERROR: "Sms Templates can't be fetched. Try again!",
  GET_ERROR: "Sms Template Detail can't be fetched. Try again!",
  ADD_ERROR: "Sms Templates can't be added. Try again!",
  DELETE_ERROR: "Sms Templates can't be deleted. Try again!",
  EDIT_ERROR: "Sms Templates can't be edited. Try again!",
};

export const PHONENUMBERSLIST = {
  TYPE: 'PHONENUMBERLIST',
  LIST_ERROR: "Phone Numbers List can't be fetched. Try again!",
  GET_ERROR: "Phone Number Detail can't be fetched. Try again!",
  ADD_ERROR: "Phone Number can't be added. Try again!",
  DELETE_ERROR: "Phone Number can't be deleted. Try again!",
  EDIT_ERROR: "Phone Number can't be edited. Try again!",
};

export const TASKS = {
  TYPE: 'TASKS',
  LIST_ERROR: "Tasks can't be fetched. Try again!",
  GET_ERROR: "Task Detail can't be fetched. Try again!",
  ADD_ERROR: "Task can't be added. Try again!",
  DELETE_ERROR: "Task can't be deleted. Try again!",
  EDIT_ERROR: "Task can't be edited. Try again!",
};

export const TASKLOGS = {
  TYPE: 'TASK',
  LIST_ERROR: "Tasks history can't be fetched. Try again!",
  GET_ERROR: "Task history can't be fetched. Try again!"
};

export const VEHICLEDATAYEARS = {
  TYPE: 'VEHICLEDATAYEARS',
  LIST_ERROR: "Years can't be fetched. Try again!",
  GET_ERROR: "Years Detail can't be fetched. Try again!",
  ADD_ERROR: "Years can't be added. Try again!",
  DELETE_ERROR: "Years can't be deleted. Try again!",
  EDIT_ERROR: "Years can't be edited. Try again!",
};

export const VEHICLEDATABRAND = {
  TYPE: 'VEHICLEDATABRAND',
  LIST_ERROR: "Brand can't be fetched. Try again!",
  GET_ERROR: "Brand Detail can't be fetched. Try again!",
  ADD_ERROR: "Brand can't be added. Try again!",
  DELETE_ERROR: "Brand can't be deleted. Try again!",
  EDIT_ERROR: "Brand can't be edited. Try again!",
};

export const VEHICLEDATAMODEL = {
  TYPE: 'VEHICLEDATAMODEL',
  LIST_ERROR: "Model can't be fetched. Try again!",
  GET_ERROR: "Model Detail can't be fetched. Try again!",
  ADD_ERROR: "Model can't be added. Try again!",
  DELETE_ERROR: "Model can't be deleted. Try again!",
  EDIT_ERROR: "Model can't be edited. Try again!",
};

export const VEHICLEDATATRIM = {
  TYPE: 'VEHICLEDATATRIM',
  LIST_ERROR: "Trim can't be fetched. Try again!",
  GET_ERROR: "Trim Detail can't be fetched. Try again!",
  ADD_ERROR: "Trim can't be added. Try again!",
  DELETE_ERROR: "Trim can't be deleted. Try again!",
  EDIT_ERROR: "Trim can't be edited. Try again!",
};

export const VEHICLEDATLOGS = {
  TYPE: 'VEHICLEDATA',
  LIST_ERROR: "Vehicle Data history can't be fetched. Try again!",
  GET_ERROR: "Vehicle Data history can't be fetched. Try again!"
};


export const ENROLLMENTHISTORY = {
  TYPE: 'ENROLLMENTHISTORY',
  LIST_ERROR: "Enrollment history can't be fetched. Try again!",
  GET_ERROR: "Enrollment history Detail can't be fetched. Try again!"
};

export const EMAILTEMPLATE = {
  TYPE: 'EMAILTEMPLATE',
  LIST_ERROR: "Email Templates can't be fetched. Try again!",
  GET_ERROR: "Email Template Detail can't be fetched. Try again!",
  ADD_ERROR: "Email Templates can't be added. Try again!",
  DELETE_ERROR: "Email Templates can't be deleted. Try again!",
  EDIT_ERROR: "Email Templates can't be edited. Try again!",
};

export const EMAILTEMPLATELOGS = {
  TYPE: 'EMAILTEMPLATE',
  LIST_ERROR: "Email Templates history can't be fetched. Try again!",
  GET_ERROR: "Email Templates history can't be fetched. Try again!"
};

export const WHOLESALEQUOTESLOGS = {
  TYPE: 'WHOLESALEQUOTESLOGS',
  LIST_ERROR: "Wholesale quotes history can't be fetched. Try again!",
  GET_ERROR: "Wholesale quotes history can't be fetched. Try again!"
};

export const WORKFLOWSETTINGS = {
  TYPE: 'WORKFLOWSETTINGS',
  LIST_ERROR: "Workflow settings history can't be fetched. Try again!",
  GET_ERROR: "Workflow settings history can't be fetched. Try again!"
};